export default "__VITE_ASSET__qI_0MKW9__"